export const userRole = {
    ADMIN: 'admin',
    SPORTSBOX_INSTRUCTOR: 'Sportsbox-Instructor',
    SPORTSBOX_USER: 'Sportsbox-User',
    SPORTSBOX_ENTERPRISE: 'Sportsbox-Enterprise',
};
